import React from 'react';
import PropTypes from 'prop-types';

class CardListItem extends React.Component {
  render() {
    const { text, info, highlightedText } = this.props;

    if ( info ) {
      return (
        <li className="cardTooltip">
          <strong>{highlightedText}</strong>
          { text && text }
          <img src="/assets/icon/info.svg" className="cardTooltipImage" alt={text} />
          <span className="cardTooltipBox">{ info }</span>
        </li>
      );
    }

    return (
      <li>
        <strong>{highlightedText}</strong>
        { text && text }
      </li>
    );
  }
}

CardListItem.propTypes = {
  highlightedText: PropTypes.string.isRequired,
  text: PropTypes.string,
  info: PropTypes.string
};

export default CardListItem;
